'use client'
import { useTranslations } from 'next-intl'
import type { JSX } from 'react'

import FilledButton from '@/components/Button/FilledButton'
import { Link } from '@/lib/i18n/navigation'

const SignInButton = (): JSX.Element => {
  const t = useTranslations('signIn')

  return (
    <FilledButton asChild theme="light">
      <Link href="/signin">{t('title')}</Link>
    </FilledButton>
  )
}

export default SignInButton
